import React, { useContext, useEffect, useState } from "react";
import { Btn, CommonModal, H5 } from "../../../AbstractElements";
import CustomAutoSuggest from "../../../CommonElements/CustomAutoSuggest";
import { filterCustomers, getBookingById } from "../../../Services/Booking.service";
import ActionOptions from "../../../Components/Common/Component/ActionOptions";
import QuickActions from "../../../Components/TripManagement/BookingHistory/QuickActions";
import { customerColumns } from "../../../Data/Customers/CustomerTrips";
import BookingContext from "../../../_helper/Booking";
import SharedDataContext from "../../../_helper/SharedData";
import { formatDateString, showAlert } from "../../../Services/Shared.service";
import { getBookingsByCustomer } from "../../../Services/Customer.service";
import { DropdownItem } from "reactstrap";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import CommonDataTable from "../../../Components/Common/Component/CommonDataTable";

const CustomerSearchModal = ({
    Large,
    title,
    LargeModaltoggle,
    toggleBookCabModal,toggleEditCabModal,
    BookingModalToggle
}) => {
    const [customerDetails, setCustomerDetails] = useState({})
    const [customerBookingsData, setCustomerBookingsData] = useState([])
    // ----booking  contest
    const { setBookingObj, setBookingEditType,setBookingEditTypes,setBookingObjs,toggleeditCabModal} = useContext(BookingContext)
    const { setShowApiLoader, cityData } =
        useContext(SharedDataContext);

    const { register, setValue, reset, handleSubmit,formState: {errors} } = useForm({
        defaultValues: {
            phoneNumber: ""
        }
    })

    const onClickEditOrRebook = (bookingId, editType) => {
        getBookingById(bookingId)
            .then((bookingRes) => {
                const data = bookingRes.data;
                if (data) {

                    setBookingEditTypes(editType);
                    setBookingObjs(data);
                    // setValue("phoneNumber", "")
                    // setCustomerBookingsData([])
                    // LargeModaltoggle();
                    toggleEditCabModal();
                   
                    
                }
            })
            .catch((err) => {
                showAlert("error", "Something went wrong");
            });
    };

    const searchCustomers = async (inputValue) => {
        if (inputValue) {
            return filterCustomers(inputValue).then((result) => {
                if (result.data.length > 0) {
                    let data = result.data.map((element) => {
                        return {
                            value: element,
                            label: element.mobile,
                        };
                    });
                    return data;
                }
                return [];
            });
        }
    };

    useEffect(() => {
        return () => {
            setValue("phoneNumber", "")
            setCustomerBookingsData([])
        }
    }, [Large])

    const fetchCustomerBookings = (custId) => {
        const obj = {
            customerId: custId,
            page: "0",
            size: "5"
        };

        getBookingsByCustomer(obj)
            .then((result) => {
                if (result.data && result.data.list) {
                    const processData = result.data.list.map((element, index) => {
                        return {
                            booking_number: element.megaCabsBookingNo ? element.megaCabsBookingNo : '-',
                            pickup_time: element.pickUpDateTime ? formatDateString(element.pickUpDateTime, "MMM DD,YYYY HH:mm") : '-',
                            pickup_location: element.pickUpAddress ? element.pickUpAddress : '-',
                            status: element.currentBookingStatusType ? element.currentBookingStatusType : '-',
                            drop_location: element.destAddress ? element.destAddress : '-',
                            action: (
                                <Btn
                                    attrBtn={{
                                        color: "primary",
                                        className: "d-block",
                                        onClick: (e) => onClickEditOrRebook(element.id, "Rebook"),
                                        title: "Rebook"
                                    }}
                                >
                                    <i className="fa fa-repeat"></i>
                                </Btn>
                            ),
                        }
                    });
                    setCustomerBookingsData(processData);
                }
            })
            .catch((err) => {
                showAlert("error", "Something went wrong");
            });
    };

    const handlePhoneNumberSelect = (data) => {
        const value = data.value;
        setValue("phoneNumber", value?.mobile);
        setCustomerDetails(value)
        // setValue("customerName", value?.fullName);
        // setValue("gender", value?.gender);
        // setValue("email", value?.email);
        // setValue("custId", value?.id);
        // if (value?.isVip) {
        //     setValue("cust", "Vip");
        // } else if (value?.isCorporateAccount) {
        //     setValue("customerType", "Corporate");
        // }
        // if (value?.city) {
        //     console.log(cityData, "cityData");
        //     const cityObj = cityData.find(
        //         (element) =>
        //             element.value.name.toLowerCase() == value?.city.toLowerCase()
        //     );
        //     console.log(cityObj, "cityObj");
        //     if (cityObj && Object.keys(cityObj).length > 0) {
        //         console.log("callleddd");
        //         setValue("city", cityObj.value)
        //     }
        // }
        fetchCustomerBookings(value?.id)
    };

    const createBooking = () => {
        setBookingObj((prevData) => {
            return {
                ...prevData,
                custName: customerDetails?.fullName,
                custMobile: customerDetails?.mobile,
                custId: customerDetails?.id,
                custEmail: customerDetails?.email,
                gender: customerDetails?.gender,
            };
        });
        setBookingEditType("Book");
        // setValue("phoneNumber", "")
        // setCustomerBookingsData([])
        // LargeModaltoggle();
        toggleBookCabModal();
    }

    return (
        <CommonModal
            isOpen={Large}
            title={title}
            toggler={LargeModaltoggle}
            size="lg"
        >
            <form onSubmit={handleSubmit(createBooking)}>
                <div>
                    <CustomAutoSuggest
                        id={"Phone Number"}
                        registerName={"phoneNumber"}
                        handleSelectChange={handlePhoneNumberSelect}
                        options={searchCustomers}
                        placeholder={"Enter Phone Number to create booking"}
                        register={register}
                        inputType={"number"}
                        inputProps={{
                            minLength: {
                                value: 10,
                                message: "Phone number cannot be less than 10",
                            },
                            maxLength: {
                                value: 10,
                                message: "Phone number cannot be more than 10",
                            },
                        }}
                        dependentRegisterName={""}
                    />
                    <span style={{ color: "red" }}>
                        {errors?.phoneNumber?.message}
                    </span>
                </div>
                <div style={{ display: "flex", justifyContent: "center" }}>
                    <Btn
                        attrBtn={{
                            color: "primary",
                            // className: "w-100",
                            style: { margin: "20px 0px" },
                            type: "submit"
                        }}
                    >
                        Create new booking
                    </Btn>
                </div>
            </form>
            {customerBookingsData.length > 0 ? <div>
                <H5>Customer Previous Bookings</H5>
                <div className="table-responsive customer-trips">
                    <CommonDataTable
                        options={{
                            columns: customerColumns,
                            data: customerBookingsData,
                            center: true,
                            notPagination: true
                        }}
                        loading={false}
                    />
                </div>
            </div> : null}
        </CommonModal>
    )
}
export default CustomerSearchModal